module.exports = __webpack_public_path__ + "static/1-7e3ec1cdbe0be246cc3be10a40c998c7.jpg";